export default __webpack_public_path__ + "static/media/double-rope-border-right.5d29c715.svg";